export const APP_CONFIG = {
  companyName: "RBSC Solar",
  shortName: "RBSC",
  supportEmail: "info@rbscsolar.com",
  supportPhone: "+91 99999 99999", // Replace with actual if needed
  companyAddress:
    "Office No. 11, Bhopal House Lalbagh, Hazratganj, Lucknow 226001",
  companyAddressShort: "Office No. 11, Bhopal House",
  logoPath: "/logo.png",
  year: new Date().getFullYear(),
  trackingPrefix: "RBSC-", // Useful for generating Tracking IDs
};
